<template>
    <div>
    <b-card title="Risiken eigener Geschäftsbereich - konkrete Risikoanalyse" class="mb-3 shadow" v-if="!hasRole('Lieferant')">
        <b-button v-b-toggle.help_risks pill size="sm" variant="outline-secondary" class="info-button"><em>i</em></b-button>
        <b-sidebar right id="help_risks" :title="$t(`help.info`)" backdrop-variant="dark" backdrop shadow width="600px" max-width="100%">
            <div class="px-3 py-2">
                <b-list-group>
                    <b-list-group-item>Zu jedem Score-Wert besteht eine detaillierte Aufgliederung der Antworten und der zugehörigen Scores.</b-list-group-item>
                    <b-list-group-item>Innerhalb dieser Detailansicht sind grau formatierte Fragen entweder dem Benutzer noch nicht angezeigt worden oder wurden in Abhängigkeit der gegebenen Antworten übersprungen.</b-list-group-item>
                    <b-list-group-item></b-list-group-item>
                    <b-list-group-item></b-list-group-item>
                </b-list-group>
            </div>
        </b-sidebar>

        <b-row>
            <b-col>
                <b-form-group label="Jahr" class="mb-3" v-slot="{ ariaDescribedby }">
                    <b-form-select v-model="filterYear" :aria-describedby="ariaDescribedby" class="mt-1">
                        <option v-for="year in years" :key="year.id" :value="year.id">{{ year.year }}</option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <!--<b-col>
                <b-form-group v-model="filterAuction" label="Aktion" class="mb-3" v-slot="{ ariaDescribedby }">
                    <b-form-select v-model="filterAuction" :aria-describedby="ariaDescribedby" class="mt-1" @change="fetchScores">
                        <option v-for="auction in auctions" :key="auction.id" :value="auction.id">{{ auction.title }}</option>
                    </b-form-select>
                </b-form-group>
            </b-col>-->
        </b-row>
    </b-card>

    <div v-for="item in filteredSupplierRisks" :key="item.id" v-if="item.analysis_enabled">
        <analysisComponent :user="item" :year="filterYear" />
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import riskService from '../../../../../services/Riskmanagement/RiskService';
import analysisComponent from './EGBAnalysisComponent';

export default {
    name: 'supplierscoretab',
    components: {analysisComponent},
    props: [],
    data() {
        return {
            filterScope: 'eigener Geschäftsbereich',
            filterAuction: null,
            filterYear: null,
            supplierrisks: [],
            selectedYear: null,
        }
    },
    created() {
        this.fetchYears();
        this.fetchSupplierRisks();
    },
    methods: {
        ...mapActions({
            fetchYears: 'years/fetch',
        }),
        fetchSupplierRisks() {
            this.$store.commit('loading/setLoading', true);
                riskService.listSupplierRisks()
                    .then(response => {
                        this.supplierrisks = response;
                        this.$store.commit('loading/setLoading', false);
                    }).catch(error => {
                        this.$store.commit('loading/setLoading', false);
                    });
        },
        newlineToBr: function (value) {
                return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
        },
    },
    computed: {
        ...mapGetters({
            hasRole: 'auth/hasRole',
            years: 'years/years'
        }),
        filteredSupplierRisks() {
            let result = this.supplierrisks.filter(item => {
                const filter1Match = !this.filterScope || item.lksg_scope === this.filterScope;
                const filter2Match = !!this.filterYear && this.filterYear === item.year.id;
                return filter1Match && filter2Match && (item.analysis_enabled == true);
            })
            return result;
        },
    },
}
</script>